import * as getTime from '~/skills/getTime';

const form = ({ form_status = 0, admin_status = 0, admin_upd_logs }) => {
  const isSigned = !!admin_upd_logs;
  const logic = {
    0: {
      0: '尚未儲存',
    },
    1: {
      0: '已暫存',
    },
    2: {
      0: '主管審查中',
    },
    3: {
      1: '管理者審查中',
      2: '已通過',
    },
  };

  return `${isSigned ? '更新（' : ''}${(logic[form_status] || {})[admin_status] || '狀態異常'}${isSigned ? '）' : ''}`;
};

const canEdit = props => {
  const formText = form(props);
  return (formText.match('尚未儲存') || formText.match('已暫存'));
};

const fBApply = (data = {}) => {
  const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
  const now = new Date();
  try {
    const overApplyTime = (returnInputValue(data.apply_sail_date) !== '') && (now > getTime.returnDate(data.apply_sail_date));
    const overMeetTime = (returnInputValue(data.meet_date) !== '') && (now > getTime.returnDate(data.meet_date));
    const is_review = data.is_review === '2';
    if (!overApplyTime) return '未提出申請';
    else if (!overMeetTime) return '申請中';
    else if (!is_review) return '審查中';
    else return '已通過';
  } catch {
    return '未提出申請';
  }
};

const foreignBoat = { fBApply };

export {
  form,
  canEdit,
  foreignBoat,
};
